import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-narrow-up', 'ArrowNarrowUp', [["path",{"d":"M12 5l0 14"}],["path",{"d":"M16 9l-4 -4"}],["path",{"d":"M8 9l4 -4"}]]);